import { createAction } from "@ngrx/store";
import { NavigationModel } from "../models/navigation.model";

export const NAVIGATION = createAction(
  "NAVIGATION",
  (navigation: NavigationModel) => ({ navigation }),
);
